import { overCharacterLimitMessage } from '#pplx/frontend/apps/ask/composer-ui/inputLimitMessages.js';
import { MAX_CHARACTERS_ALLOWED_TO_SUBMIT } from '#pplx/frontend/components/utils/consts.js';
import { createInputOverLimitWarningPluginFactory } from '#pplx/frontend/composer-sdk-plugins/input-over-limit-warning/inputOverLimitWarningPlugin.js';
import { useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';
const createOverLimitWarningPlugin = createInputOverLimitWarningPluginFactory();
/** Binds Ask's character limit and localized warning; callers retain their submission policy. */
export function useAskInputOverLimitWarningPlugin({ count, }) {
    const intl = useIntl();
    const formatMessage = useCallback((overBy) => intl.formatMessage(overCharacterLimitMessage, { numCharacters: overBy }), [intl]);
    return useMemo(() => createOverLimitWarningPlugin({
        count,
        limit: MAX_CHARACTERS_ALLOWED_TO_SUBMIT,
        formatMessage,
    }), [count, formatMessage]);
}
//# sourceMappingURL=useAskInputOverLimitWarningPlugin.js.map